import React from 'react'
import { CtaArrow, Link } from 'newComponents'
import classNames from 'classnames'
import './styles.scss'

const DemoFormArticleLinks = ({ data }) => {
  const { articleLinks, containerTitle: title, smallTitle } = data

  return (
    <div className="form-page-column-article-links">
      <h2
        className={classNames('form-title short-title', {
          'small-title': smallTitle
        })}
      >
        {title}
      </h2>
      {articleLinks.map((article) => (
        <div key={article.text} className="thank-you-link-groups">
          <div className="thank-you-link-group">
            <p className="thank-you-link-group-article-tag">{article.tag}</p>
            <h5 className="thank-you-link-group-link-title">{article.text}</h5>
            <Link to={article.url} className="thank-you-link-group-link">
              Learn More <CtaArrow />
            </Link>
          </div>
        </div>
      ))}
    </div>
  )
}

export default DemoFormArticleLinks
